import React from 'react';
export function Footer() {
  return <footer className="bg-dark border-t border-gray-800 py-12" data-id="element-59">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-60">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-61">
          <div className="flex-shrink-0" data-id="element-62">
            <img src="https://cdn.magicpatterns.com/uploads/mSQy5D2xr3KB3poJfjsLq1/6008aba0-2278-4ccf-a44f-f03314af6b23.png" alt="AI Web Studio Logo" className="h-[72px] md:h-[88px] w-auto opacity-90 brightness-110" data-id="element-63" />
          </div>

          <div className="flex gap-6 text-sm text-gray-400" data-id="element-64">
            <a href="#" className="hover:text-white transition-colors" data-id="element-65">
              Aviso Legal
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-66">
              Política de Privacidad
            </a>
          </div>

          <div className="text-gray-500 text-sm" data-id="element-67">
            &copy; {new Date().getFullYear()} AI Web Studio. Todos los derechos
            reservados.
          </div>
        </div>
      </div>
    </footer>;
}